import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { DEFAULT_BUBBLE } from 'custom-constants';
import { Bubble, ID } from 'domain/bubble';
import novell from 'story/novell.json';
import { RootState } from '../store';

export interface SelectedBubbleState {
  bubble: Bubble;
  bg: ID;
  border: ID;
  person: ID;
  activeStep: ID;
  attrs: Record<ID, number>;
}

const defaultVal = 0;

const initialState: SelectedBubbleState = {
  bubble: DEFAULT_BUBBLE,
  bg: defaultVal,
  border: defaultVal,
  person: defaultVal,
  activeStep: defaultVal,
  attrs: {},
};

export const selectedBubbleSlice = createSlice({
  name: 'selectedBubble',
  initialState,
  reducers: {
    initialStep: (state, action: PayloadAction<ID>) => {
      const step = novell.steps[action.payload];
      state.activeStep = action.payload;
      state.bg = novell.bubbles[step.bubbleId].background || 0;
      state.border = novell.bubbles[step.bubbleId].border;
      state.person = novell.bubbles[step.bubbleId].person;
      state.bubble = novell.bubbles[step.bubbleId];
    },
    nextStep: (state, action: PayloadAction<{ oIdx: ID }>) => {
      const { oIdx } = action.payload;
      const stepId = state.activeStep;

      let step = novell.steps[stepId];
      let activeStep = null;

      if (oIdx >= 0 && step?.attr) {
        state.attrs[stepId] = oIdx;
      }

      if (step?.depAttr !== undefined && step?.depAttr !== step.id) {
        activeStep = step.branches[state.attrs[step?.depAttr]];
      } else if (step.branches.length > 1) {
        activeStep = step.branches[oIdx];
      } else {
        [activeStep] = step.branches;
      }

      state.activeStep = activeStep;
      step = novell.steps[activeStep];
      state.bg = novell.bubbles[step.bubbleId].background ?? state.bg;
      state.border = novell.bubbles[step.bubbleId].border;
      state.person = novell.bubbles[step.bubbleId].person;
      state.bubble = novell.bubbles[step.bubbleId];
    },
  },
});

export const { nextStep, initialStep } = selectedBubbleSlice.actions;

export const getSelectedBubble = (state: RootState) => state.selectedBubble.bubble;
export const getSelectedBG = (state: RootState) => state.selectedBubble.bg;
export const getSelectedBorder = (state: RootState) => state.selectedBubble.border;
export const getSelectedPerson = (state: RootState) => state.selectedBubble.person;

export const selectedBubbleReducer = selectedBubbleSlice.reducer;
